import React from 'react';
import { useSelector } from 'react-redux';
import { Navigate } from 'react-router-dom';
import Routes from '../../../../constants/routes';
import { isWorldWithEnabledAuthorMetrics } from '../../../../utils/is-world-with-enabled-author-metrics';
import AsyncComponent from '../../../index';

export const ChartsRoute = () => {
    const user = useSelector((state: RootState) => state.main.user);
    const isMetricsAuthor = user.details.totalMaterials > 0 && isWorldWithEnabledAuthorMetrics(user.country);

    if (isMetricsAuthor) {
        return <Navigate to={Routes.METRICS.path} replace />;
    }

    return <AsyncComponent componentName='Charts' meta={Routes.CHARTS.meta} />;
};
